
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const DELETE_FLASH_MESSAGE = 'DELETE_FLASH_MESSAGE';
export const POP_FLASH_MESSAGE = 'POP_FLASH_MESSAGE';


/**
 * @typedef {Object} FlashMessage
 * @property {string} text
 * @property {'success'|'error'|'primary'|'secondary'|'warning'|'info'|'light'|'dark'} type
 * @property {function?} onClose
 *
 * @param {FlashMessage} message
 * @returns
 */
export function addFlashMessage(message) {
  return {
    type: ADD_FLASH_MESSAGE,
    message
  };
}

export function deleteFlashMessage(id) {
  return {
    type: DELETE_FLASH_MESSAGE,
    id
  };
}

export function popFlashMessage() {
  return {
    type: POP_FLASH_MESSAGE
  };
}